import http, { url } from '../../http'

const API_URL = "performance_surr"

class performance_surrAPI {

  async save(performance) {
    const response = await http(`${API_URL}/save`, 'POST', performance)
    return response
  }
 
  async getAllBrigade() {
    const response = await http(`${API_URL}`)
    return response
  } 

  async getAllperformance(id,  page, search) {
    const response = await http(`${API_URL}/company/${id}?page=${page}&search=${search}` , 'POST')
    return response
  } 
 
  async getPerformance(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async update(id, brigade) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', brigade)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

 
  
}

export default new performance_surrAPI()